module.exports = __webpack_public_path__ + "static/media/corporate-enquiries.02a82798.svg";